import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { global } from '../../../shared/global';

@Injectable({
  providedIn: 'root'
})
export class SchoolloginService {

  constructor(private http: HttpClient) { }

  fillBoard(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillBoard', data, global.httpOptions);
  }
  fillMedium(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillMedium', data, global.httpOptions);
  }
  fillInstituteType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillInstituteType', data, global.httpOptions);
  }
  fillOffice(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillOffice', data, global.httpOptions);
  }
  fillTypeOfTrust(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillTypeOfTrust', data, global.httpOptions);
  }
  fillSection(data)
  {
    return this.http.post(global.baseAPIUrl + 'Registration/fillSection', data, global.httpOptions);
  }
  fillState(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillState', data, global.httpOptions);
  }
  fillCity(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillCity', data, global.httpOptions);
  }
  fillSchoolType(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolType', data, global.httpOptions);
  }
  fillSchoolLocation(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolLocation', data, global.httpOptions);
  }
  fillDesignation(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillDesignation', data, global.httpOptions);
  }
  fillInfrastructure(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillInfrastructure', data, global.httpOptions);
  }
  fillEmployeeType(data)
  {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillEmployeeType', data, global.httpOptions);
  }
  login(data)
  {
    return this.http.post(global.baseAPIUrl + 'Login/schoolLogin', data, global.httpOptions);
  }
  forgetPasswordSchool(data)
  {
    return this.http.post(global.baseAPIUrl + 'Login/forgetPasswordSchool', data, global.httpOptions);
  }
  saveRegistrationDetails(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/saveRegistrationRequest', data);
  }
  fillRegistrationRequestDetail(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/fillRegistrationRequestDetail', data);
  }
  
  checkRequestStatus(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/checkRequestStatus', data);
  }
  fillRegistrationDetailByCollegeCode(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/fillRegistrationDetailByCollegeCode', data);
  }

  saveCollegeInfo(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/saveCollegeInfo', data);
  }
  saveEducationInfo(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/saveEducationInfo', data);
  }
  saveOtherInfo(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/saveOtherInfo', data);
  }
  saveInfrastructureInfo(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/saveInfrastructureInfo', data);
  }
  getRegisterEmailID(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/getRegisterEmailID', data);
  }
  collegeSendOTP(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/sendOtpRegisterEmailID', data);
  }
  sendOtpRegisterEmailID(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/sendOtpRegisterEmailID', data);
  }
  sendOTP(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/sendOTP', data);
  }
  verifyOTP(data)
  {
    return this.http.post(global.baseAPIUrl + 'RegistrationRequest/verifyOTP', data);
  }
}
